import { axios } from '@/plugins/axios-pol'

const basePath = '/equipamiento/api/Equipamiento/subsedes'

export default class SubsedeAsignacionApiRepository {
  async getAllSubsedes() {
    const { data } = await axios.get(`${basePath}/asignaciones`)
    return data.data
  }

  async getAsignacionesBySubsede(idSubSede) {
    const { data } = await axios.get(`${basePath}/${idSubSede}/asignaciones`)
    return data.data
  }

  async createAsignacion(idSubSede, payload) {
    const body = this.#buildAsignacionFormData(payload)
    const { data } = await axios.post(`${basePath}/${idSubSede}/asignaciones`, body)
    return data.data
  }

  async updateAsignacion(idSubSede, idDetalleAsignacion, payload) {
    const body = this.#buildAsignacionFormData(payload)
    const { data } = await axios.put(`${basePath}/${idSubSede}/asignaciones/${idDetalleAsignacion}`, body)
    return data.data
  }

  #buildAsignacionFormData(payload) {
    const { equipoAsignado, adjunto, ...rest } = payload
    const formData = new FormData()

    Object.entries(rest).forEach(([key, value]) => {
      formData.append(key, value === null || value === undefined ? '' : value)
    })

    formData.append('equipoAsignado', JSON.stringify(equipoAsignado || []))

    if (adjunto) {
      formData.append('adjunto', adjunto)
    }

    return formData
  }
}
